import ContactCard from './components/ContactCard';
import NotificationsContent from './components/NotificationsContent';
import styles from './styles.module.scss';
import TabContentWrapper from 'pages/Profile/components/TabContentWrapper';

const Notifications = ({
  contactId,
  contactPhones,
  contactEmail,
  contactName,
  notificationPref,
  disableAll,
}) => {
  if (!contactId) return null;

  return (
    <TabContentWrapper setMargin contentHeightFull>
      <div className={styles.notificationsTab}>
        <ContactCard contactPhones={contactPhones} contactEmail={contactEmail} />
        <NotificationsContent
          contactId={contactId}
          contactName={contactName}
          notificationPref={notificationPref}
          disableTextNotification={true}
          disableAll={disableAll}
        />
      </div>
    </TabContentWrapper>
  );
};

export default Notifications;
